import { Component, OnInit } from '@angular/core';
import { SitemapMessages } from 'src/app/modules/shared/models/component-messages/site-map-messages';

@Component({
  selector: 'app-site-map',
  templateUrl: './site-map.component.html',
  styleUrls: ['./site-map.component.scss']
})
export class SiteMapComponent implements OnInit {

  constructor() {
  }

  public siteMapMessages = new SitemapMessages();

  public ngOnInit() {
  }

}
